import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import DateDivider from "../dateDivider";
import ChatBubble from "../chatBubble";

const ChatMessageList = ({
  messages,
  theme,
  loading,
  searchTerm,
  activeMatchIndex,
  matchedIndexes,
}) => {
  let lastDate = null;

  // 🔥 Auto scroll to active match
  useEffect(() => {
    if (
      activeMatchIndex !== null &&
      matchedIndexes &&
      matchedIndexes.length > 0
    ) {
      const messageIndex = matchedIndexes[activeMatchIndex];
      const el = document.getElementById(`message-${messageIndex}`);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [activeMatchIndex, matchedIndexes]);

  // 🔥 Highlight search word inside text
  const highlightText = (text) => {
    if (!searchTerm?.trim()) return text;

    const regex = new RegExp(`(${searchTerm})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, i) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#ffeb3b",
            padding: "2px 4px",
            borderRadius: "4px",
          }}
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  if (loading) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {messages.map((msg, index) => {
        const msgDate = new Date(msg.created_date).toDateString();
        const showDate = msgDate !== lastDate;
        lastDate = msgDate;

        const isMatched =
          matchedIndexes && matchedIndexes[activeMatchIndex] === index;

        return (
          <Box id={`message-${index}`} key={msg.id}>
            {showDate && <DateDivider date={msg.created_date} />}

            <Box
              sx={{
                display: "flex",
                justifyContent: msg.isMine ? "flex-end" : "flex-start",
                mb: 1.5,
                backgroundColor: isMatched
                  ? "rgba(255, 235, 59, 0.25)"
                  : "transparent",
                borderRadius: 2,
                transition: "0.3s",
              }}
            >
              <ChatBubble
                msg={{
                  ...msg,
                  message_content: highlightText(msg.message_content),
                }}
                theme={theme}
              />
            </Box>
          </Box>
        );
      })}
    </>
  );
};

export default ChatMessageList;
